import LNB from './LNB';

export default LNB;
